import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import { columns } from "./columns";
import { Grid } from "@mui/material";
import { GlobalBox } from "components/Box/GlobalBox";
import { useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import { reasonNotesOptions } from "./config";

export const TableNotes = () => {
  const tableKey = "invoicesCash"
  const { notes, reasonSelect } = useSelector(({ cashInvoices }) => cashInvoices);
  const { buildTableConfig } = useSearch();
  const { configTables } = useSelector(({ search }) => search);
  const hasDiscount = reasonSelect === reasonNotesOptions.discount || notes.some(note => note.discountAmount);

  useEffect(() => {
      !configTables[tableKey] && buildTableConfig(tableKey, 10);
    }, [configTables[tableKey]]);

  return (
    <Grid item xs={12} md={8}>
      <GlobalBox title="Notas" head style={{ boxShadow: "none", margin: 0 }}>
        <CardTable
          columns={columns(hasDiscount ? reasonNotesOptions.discount : reasonSelect)}
          data={notes}
          showPageSize={false}
          blockBtn
          style={{ boxShadow: "none" }}
          gridTable={{ padding: 0, margin: 0 }}
          prev="<"
          next=">"
          panelStyle={{ overflow: "none" }}
          tableKey={tableKey}
        />
      </GlobalBox>
    </Grid>
  );
};
